import "./Consultation.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ScheduleYourSession from "./sections/ScheduleYourSession";
import ConsultationFaq from "./sections/ConsultationFaq";
import FooterInformation from "@/reusable_sections/Footer";
export default function ConsultationPage() {
  return <div>
      <MainNavigation />
      <ScheduleYourSession />
      <ConsultationFaq />
      <FooterInformation />
    </div>;
}